import { render, staticRenderFns } from "./teaAssignHomework.vue?vue&type=template&id=0396dd2a&scoped=true"
import script from "./teaAssignHomework.vue?vue&type=script&lang=js"
export * from "./teaAssignHomework.vue?vue&type=script&lang=js"
import style0 from "./teaAssignHomework.vue?vue&type=style&index=0&id=0396dd2a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0396dd2a",
  null
  
)

export default component.exports